// src/components/shell/Sidebar/SidebarGlobalItems.tsx
// Bottom-of-rail group: help, profile, settings, and (dev-only) impersonation.
// Each popover component owns its own trigger + popup; this file just composes
// them inside a single visual group at the foot of the sidebar.
import { HelpPopover } from "@/components/shell/popovers/HelpPopover";
import { ProfilePopover } from "@/components/shell/popovers/ProfilePopover";
import { OrgPopover } from "@/components/shell/popovers/OrgPopover";
import {
  SettingsPopover,
  type SettingsPopoverLeadsControls,
} from "@/components/shell/popovers/SettingsPopover";
import { ImpersonationPopover } from "@/components/shell/popovers/ImpersonationPopover";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";

export type SidebarGlobalItemsProps = {
  expanded: boolean;
  /** Closes the mobile drawer after a popover action (no-op on rail/desktop). */
  onAfterAction?: () => void;
  leadsControls?: SettingsPopoverLeadsControls | null;
  mode: PrimaryMode;
  salesperson: { name: string } | null;
  location: { name: string } | null;
};

export function SidebarGlobalItems({
  expanded,
  onAfterAction,
  leadsControls = null,
  mode,
  salesperson,
  location,
}: SidebarGlobalItemsProps) {
  return (
    <div className="border-t border-gray-200 dark:border-gray-800 px-2 py-2 space-y-1">
      <HelpPopover
        key={mode}
        expanded={expanded}
        mode={mode}
        salesperson={salesperson}
        location={location}
        onAfterAction={onAfterAction}
      />
      <ProfilePopover expanded={expanded} onAfterAction={onAfterAction} />
      <OrgPopover expanded={expanded} onAfterAction={onAfterAction} />
      <SettingsPopover expanded={expanded} onAfterAction={onAfterAction} leadsControls={leadsControls} />
      <ImpersonationPopover expanded={expanded} onAfterAction={onAfterAction} />
    </div>
  );
}
